import React, { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { API_ENDPOINT } from "../../../../services/api/resources";
import classes from "./charts.module.css";
import { useSelector } from "react-redux";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const VendorOnboardChart = () => {
  const [view, setView] = useState("chart");
  const [chartData, setChartData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const Data = useSelector((state) => state.loginData.value);
  // const org_token = Data?.organization_token;
  const user_token = Data?.user?.token || Data?.user_token;

  const fetchData = () => {
    const params = {};
    if (fromDate) params.from = fromDate;
    if (toDate) params.to = toDate;

    axios
      .post(API_ENDPOINT.vendor_onboard_trend, {
        org_token: user_token,
        from: fromDate || undefined,
        to: toDate || undefined,
      })

      .then((res) => {
        const initiated = res.data.initiated.map((item) => ({
          date: item.date,
          count: item.count,
        }));
        const onboarded = res.data.onboarded.map((item) => ({
          date: item.date,
          count: item.count,
        }));

        const allDates = [
          ...new Set([
            ...initiated.map((i) => i.date),
            ...onboarded.map((o) => o.date),
          ]),
        ].sort();

        const initiatedMap = Object.fromEntries(
          initiated.map((i) => [i.date, i.count])
        );
        const onboardedMap = Object.fromEntries(
          onboarded.map((o) => [o.date, o.count])
        );

        const combined = allDates.map((date) => ({
          date,
          initiated: initiatedMap[date] || 0,
          onboarded: onboardedMap[date] || 0,
        }));

        setTableData(combined);

        const chart = {
          labels: combined.map((d) => d.date),
          datasets: [
            {
              label: "Initiated",
              data: combined.map((d) => d.initiated),
              borderColor: "rgba(255, 206, 86, 1)",
              backgroundColor: "rgba(255, 206, 86, 0.3)",
              tension: 0.4,
              fill: true,
            },
            {
              label: "Onboarded",
              data: combined.map((d) => d.onboarded),
              borderColor: "rgba(54, 162, 235, 1)",
              backgroundColor: "rgba(54, 162, 235, 0.3)",
              tension: 0.4,
              fill: true,
            },
          ],
        };

        setChartData(chart);
      });
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  if (!chartData) return <p>Loading...</p>;

  return (
    <div className={classes.invoiceChartWrapper} style={{ marginTop: "10px" }}>
      {/* Date Filters */}
      <div className={classes.chartHeader}>
        <h2 className={classes.chartTitle}>
          Vendor Onboarding: Initiated vs Onboarded
        </h2>

        {/* <div style={{display:'flex',gap:'10px'}}>
          <label>
            From:{" "}
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </label>
          <label style={{fontSize:'14px'}}>
            To:{" "}
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </label>
        </div>

        <button onClick={() => setView(view === "chart" ? "table" : "chart")}>
          {view === "chart" ? "Show Table" : "Show Chart"}
        </button> */}
      </div>

      <div>
        {/* Chart or Table */}
        {view === "chart" ? (
          <Line
            data={chartData}
            options={{
              responsive: true,
              plugins: {
                title: {
                  display: false,
                  text: "Vendor Onboarding: Initiated vs Onboarded",
                },
                legend: { position: "top" },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  grid: { display: true, color: "#e0e0e0" },
                },
                x: { grid: { display: false } },
              },
            }}
          />
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f4f4f4" }}>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>
                  Date
                </th>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>
                  Initiated
                </th>
                <th style={{ padding: "8px", border: "1px solid #ccc" }}>
                  Onboarded
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {row.date}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {row.initiated}
                  </td>
                  <td style={{ padding: "8px", border: "1px solid #ccc" }}>
                    {row.onboarded}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default VendorOnboardChart;
